<app-header></app-header>

<div class="container main-page">
  <div class="row">
    <div class="col-md-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">Product ID</td>
            <td>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedproductId"
                placeholder=""
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">Published Date</td>
            <td>
              <app-drop-down-single-select
                [DropDownOptions]="selectTypeDropDownOptions"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'publishedDate'"
              ></app-drop-down-single-select>
            </td>
            <td>
              <app-date-select
                [additionalClasses]="'float-left'"
                [product]=""
                type="publishedDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="container">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button type="submit" class="btn btn-primary btn-pkt" (click)="search()">
        Search
        <i class="bi bi-search ps-1"></i>
      </button>
      <button
        type="submit"
        class="btn btn-primary btn-pkt"
        (click)="downloadReport()"
      >
        Download
        <i class="bi bi-download ps-1"></i>
      </button>
    </div>
  </div>

  <div class="container table-responsive" style="overflow-x: auto;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="width-10">Product ID</th>
          <th scope="col" class="width-15">Contract Name</th>
          <th scope="col" class="width-10">Advances</th>
          <th scope="col" class="width-20">Advance Status</th>

          <th scope="col" class="width-20">Payment Condition</th>
          <th scope="col" class="width-15">Number of Chapters</th>
          <th scope="col" class="width-15">Amount</th>
          <th scope="col" class="width-15">Royalty Rates</th>
          <th scope="col" class="width-15">Published Date</th>
          <th scope="col" class="width-15">Book Status</th>

          <th scope="col" class="width-15">Currency</th>

          <th scope="col" class="width-15">isbn-13P</th>
          <th scope="col" class="width-15">Book title</th>
          <th scope="col" class="width-15">Author Name</th>
          <th scope="col" class="width-15">Amount with currency</th>
          <th scope="col" class="width-15">Payment condition</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of products">
          <ng-container *ngFor="let contract of product.contract_royalty">
            <tr
              *ngFor="let contract_line_items of contract.contract_line_items"
            >
              <td>{{product.part_number}}</td>
              <td>{{contract.name}}</td>
              <td>{{contract_line_items.advance_amount}}</td>
              <td>{{contract_line_items.advance_status}}</td>
              <td>{{contract_line_items.amount_condition}}</td>
              <td>{{contract_line_items.no_of_chapter}}</td>
              <td>{{contract_line_items.contract_advance_amount}}</td>
              <ng-container *ngFor="let royalty of contract.royalty_rate">
                <td>{{royalty.print_band_1}}</td>
              </ng-container>

              <td>{{product.date.publishing_date}}</td>
              <td>{{product?.status[0]?.name}}</td>
              <td>
                {{currencySymbol[contract_line_items.current_currency_smb]}}
              </td>

              <td>{{product.isbn_13}}</td>
              <td>{{product.name}}</td>
              <td>{{contract?.author?.name}}</td>
              <td>
                {{currencySymbol[contract_line_items.current_currency_smb]}}{{contract_line_items.advance_amount}}
              </td>
              <td>{{contract_line_items.amount_condition}}</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>
